<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta content="text/html; charset=utf-8" http-equiv="Content-Type"/>
<title>Remembering Farley</title>
<link href="style.css" rel="stylesheet" type="text/css"/>
<p class="textn"> </p>
<p class="textn"> </p>
<p class="textn"> </p>
<p class="textn">In my life, the question has gone from “How does
  Mom know?”</p>
<p class="textn">to the more horrifying: “How much more does Mom
know that I don’t know she knows?”</p>
<p class="textn">to the truly baffling: “How much more could there
possibly be to find out?”</p>
<p class="text">It turns out, quite a lot.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mom028.vue?a36804ec